import { useEffect } from 'react';
import Logo from '../SiteBoard_Logo';

const ConnectingOverlay = ({message = 'loading'}) => {
  useEffect(() => {
    if(typeof document.activeElement === 'object') {
      document.activeElement.blur();
    }
  }, []);

  return (
    <div className='flex h-screen w-screen fixed bg-[#333] top-0 left-0 justify-center items-center'>
      <div className='relative z-[1] flex rounded-lg py-6 px-10 items-center justify-center font-semibold text-white gap-x-2'>
        <div className='animate-[spin_1s_linear_infinite]'>
          <Logo size='2.6em' />
        </div>
        <div className='flex flex-col justify-center items-center'>
          <p className='select-none text-white text-[2.4em] leading-[0.8]'>{process.env.REACT_APP_WEBSITE_NAME}</p>
          {/*<p className='select-none text-[#888] text-[1.2em]'>Connecting</p>*/}
        </div>
      </div>
      <img width='1536' height='1024' className='absolute top-0 left-0 w-[100vw] h-[100vh] object-cover object-top' src='/images/constructionSite3.jpg' alt='a construction site' />
    </div>
  );
};

export default ConnectingOverlay;
